import { ImageAsset } from './image-asset.model';

export class ToroStation
{
    static maxRunTime = 12 * 60 * 60;

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    // TODO: Complete Model

    public Name: string;
    public Description: string;
    public StationNumber = 0;

    public ImageId: number;
    public CycleTime: number;
    public SoakTime: number;

    public IsActive = false;
    public IsDisplayed = true;
    public ImageAssetId: number;
    public UseMvPumpStation: boolean;
    public ImageAsset: ImageAsset;
    public LxcStationSettings : {
        RainSensor1OptIn:boolean,
        RainSensor2OptIn:boolean,
        MasterValveOptIn:number,
        FlowSensor1OptIn:boolean,
        FlowSensor2OptIn:boolean
    }
}
